import React, { createContext, useCallback, useContext, useState, useMemo } from 'react';
import { isEqual, isFunction } from 'lodash';
import { initialFilter } from './KurbanReportUIHelpers';
import queryString from 'query-string'
import { useLocation } from 'react-router-dom';


const KurbanReportUIContext = createContext();

export function useKurbanReportUIContext() {
    return useContext(KurbanReportUIContext);
}

export const KurbanReportUIConsumer = KurbanReportUIContext.Consumer;

export function KurbanReportUIProvider({ kurbanReportUIEvents, children }) {
    const { search } = useLocation()

    useMemo(() => {
        const params = queryString.parse(search)
        // const params = new URLSearchParams(search);
        const kurban_hid = params.kurban_hid
        const thk_area_uuid = params.thk_area_uuid
        const thk_livestock_uuid = params.thk_livestock_uuid
        const status = params.status
        const start_date = params.start_date
        const end_date = params.end_date
        const page = params.page
        const page_size = params.page_size
        const sortOrder = params.sortOrder
        const sortField = params.sortField
        if (kurban_hid !== null) initialFilter.filter.kurban_hid = kurban_hid
        if (thk_area_uuid !== null) initialFilter.filter.thk_area_uuid = thk_area_uuid
        if (thk_livestock_uuid !== null) initialFilter.filter.thk_livestock_uuid = thk_livestock_uuid
        if (status !== null) initialFilter.filter.status = status
        if (start_date !== null) initialFilter.filter.start_date = start_date
        if (end_date !== null) initialFilter.filter.end_date = end_date
        if (page) initialFilter.pageNumber = Number(page)
        if (page_size) initialFilter.pageSize = Number(page_size)
        if (sortOrder) initialFilter.sortOrder = sortOrder
        if (sortField) initialFilter.sortField = sortField
    }, [search])

    // console.log(kurban_hid);

    const [queryParams, setQueryParamsBase] = useState(initialFilter);


    const setQueryParams = useCallback((nextQueryParams) => {
        setQueryParamsBase((prevQueryParams) => {
            if (isFunction(nextQueryParams)) {
                nextQueryParams = nextQueryParams(prevQueryParams);
            }

            if (isEqual(prevQueryParams, nextQueryParams)) {
                return prevQueryParams;
            }

            return nextQueryParams;
        });
    }, []);

    let initKurbanReport = {
        kurban_hid: "",
        thk_area_uuid: '',
        thk_livestock_uuid: '',
        status: "",
        start_date: '',
        end_date: "",

    };

    const value = {
        queryParams,
        setQueryParamsBase,
        setQueryParams,
        initKurbanReport,
        newKurbanReportButtonClick: kurbanReportUIEvents.newKurbanReportButtonClick,
        openEditKurbanReportPage: kurbanReportUIEvents.openEditKurbanReportPage,
    };

    return (
        <KurbanReportUIContext.Provider value={value}>
            {children}
        </KurbanReportUIContext.Provider>
    );
}
